import { Component } from "@angular/core"
import { AppBarComponent } from "../../../shared/components/app-bar/app-bar.component"
import { MainContentComponent } from "../../../shared/components/main-content/main-content.component"

@Component({
  selector: "app-about",
  standalone: true,
  imports: [AppBarComponent, MainContentComponent],
  templateUrl: "./about.component.html",
  styleUrl: "./about.component.scss",
})
export class AboutComponent {}
